import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { func } from 'prop-types';
import noop from 'lodash/noop';
import Footer from '../Footer';

const FooterContainer = ({ oneTrustReadyCallBack, consentChangedCallback, trackingCallback }) => {
  const {
    oneTrustUrl,
    optanonToken,
  } = useSelector(state => state.propsData);
  return <Footer
    oneTrustUrl={oneTrustUrl}
    optanonToken={optanonToken}
    trackingCallback={trackingCallback}
    oneTrustReadyCallBack={oneTrustReadyCallBack}
    consentChangedCallback={consentChangedCallback}/>;
};

FooterContainer.propTypes = {
  trackingCallback: func,
  oneTrustReadyCallBack: func,
  consentChangedCallback: func,
};

FooterContainer.defaultProps = {
  trackingCallback: noop,
  oneTrustReadyCallBack: noop,
  consentChangedCallback: noop,
};

export default memo(FooterContainer);
